export default __webpack_public_path__ + "static/media/module.07064754.svg";